import React from 'react';
import Disclosure from '../disclosure';
import BlueBookButton from '../bluebook-button/BlueBookButton';
import BaseModal from '../modal/BaseModal';
import HELP_ITEMS, {
  HELP_ITEMS_BLUEBOOK_DIGITAL_EXAM,
  HELP_ITEMS_NO_BLUEBOOK,
} from '../disclosure/constants';

const HelpModal = ({ onClose, isDigitalExam }) => {
  const allItems = HELP_ITEMS.concat(
    isDigitalExam ? HELP_ITEMS_BLUEBOOK_DIGITAL_EXAM : HELP_ITEMS_NO_BLUEBOOK,
  );

  return (
    <BaseModal
      title="Help"
      size="big"
      onClose={onClose}
      wrapperClassName="h-full"
      contentClassName="h-full"
      isScrollableContent
      bottomContent={
        <BlueBookButton
          isWarning
          accessibility={{
            'data-test-id': 'button-primary',
            'aria-label': 'Close',
          }}
          className="mb-1 w-fit mx-auto !font-bold !py-[7px] !px-[23px] !h-auto !leading-[1.71em]"
          onClick={onClose}
        >
          Close
        </BlueBookButton>
      }
    >
      <div className="flex flex-col">
        <Disclosure items={allItems} />
      </div>
    </BaseModal>
  );
};

export default HelpModal;
